import { useRef, useEffect, useState } from 'react';
import styles from './index.module.less';
import { ifHaveView } from '@/utils';

const Describe = ({ text, className }) => {
  const wrapperEle = useRef(null);
  const scrollEvent = useRef(null);
  const [canAnima, setCanAnima] = useState(false);
  useEffect(() => {
    window.removeEventListener('scroll', scrollEvent.current);
    if (!canAnima) {
      scrollEvent.current = () => {
        if (ifHaveView(wrapperEle.current)) {
          setCanAnima(true);
        }
      };
      scrollEvent.current();
      window.addEventListener('scroll', scrollEvent.current);
    }

    return () => {
      window.removeEventListener('scroll', scrollEvent.current);
    };
  }, [canAnima]);
  return (
    <div ref={wrapperEle} className={`${styles.wrapper} ${canAnima ? styles.transMoveUp : ''} ${className || ''}`}>
      {text}
    </div>
  );
};

export default Describe;
